
      let Page = require('/home/toannc/ekmap-platform-map-javascript/docs/pages/controls/directions.md');
      Page = Page.default || Page;
      module.exports = {
        component: Page,
        props: {
  "frontMatter": {
    "title": "Công cụ chỉ đường",
    "description": "Sử dụng ekmap-platform-directions để tích hợp công cụ chỉ đường.",
    "topics": [
      "Directions",
      "Controls"
    ],
    "thumbnail": "control_direction",
    "order": 4,
    "contentType": "example",
    "layout": "page",
    "hideFeedback": false,
    "language": [
      "JavaScript"
    ],
    "products": [
      "Mapbox GL JS"
    ],
    "prependJs": [
      "import Example from '../../components/example';",
      "import html from './directions.html';"
    ]
  }
}
      };
    